import React, { Component } from 'react';
import pick from 'lodash/pick';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';

import { Col, Row } from 'elements';
import { detectablesListSelector } from 'redux/selectors';
import { getHolder, addHolder } from 'redux/modules/model/holder';
import { holderDetailsSelector } from 'redux/selectors';
import { HolderForm } from 'smart-components';
import { listDetectables } from 'redux/modules/model/detectable';
import { PageContentTitle } from 'components';
import { withClientId } from 'hocs';
import { wsClient } from 'index';
import { notification } from 'elements';
import './index.scss';

const COMPONENT_CSS_CLASSNAME = 'directory-new';
const bemE = suffix => `${COMPONENT_CSS_CLASSNAME}__${suffix}`;

class ContactNew extends Component {
	state = {
		loading: false,
	};
	static propTypes = {
		addHolder: PropTypes.func.isRequired,
		clientId: PropTypes.string.isRequired,
		history: PropTypes.object.isRequired,
		listDetectables: PropTypes.func.isRequired,
		match: PropTypes.object.isRequired,
	};

	openNotificationWithIcon = (type, title, msg) => {
		notification[type]({
			placement: 'bottomLeft',
			duration: 7,
			message: `${title}`,
			description: `${msg}`,
		});
	};

	handleSubmit = actions => {
		const { history } = this.props;
		const operations = Object.freeze({
			addHolder: payload => {
				this.setState({ loading: true });
				wsClient.request(
					{
						messageType: 'core.holder.add-holder',
						payload,
					},
					res => {
						this.setState({ loading: false });
						if (res.payload) {
							if (res.payload.name === "Image") {
								this.openNotificationWithIcon(
									'error',
									'Error',
									res.payload.message,
								);
							} else {
								this.openNotificationWithIcon(
									'error',
									'Error',
									'Holder with same "ID" number already exists',
								);
							}
						} else {
							this.openNotificationWithIcon(
								'success',
								'Success',
								'Holder added successfully',
							);
							history.goBack();
						}
					},
				);
			},
		});
		actions.addHolder && operations.addHolder(actions.addHolder);
	};

	render() {
		const { history } = this.props;
		return (
			<Row>
				<Col xs={24} md={10}>
					<p className={bemE('back')}>
						<a onClick={() => history.goBack()}>&laquo; Back</a>
					</p>
					<PageContentTitle>Add Contact</PageContentTitle>
					<HolderForm
						onSubmit={this.handleSubmit}
						loading={this.state.loading}
					/>
				</Col>
			</Row>
		);
	}
}

export const selector = createStructuredSelector({
	detectablesList: detectablesListSelector,
});

export const actions = {
	addHolder,
	withRouter,
	listDetectables,
};

export default compose(
	withClientId,
	connect(
		selector,
		actions,
	),
)(ContactNew);



// WEBPACK FOOTER //
// ./src/pages/directory/contact-new/index.js